import { SelectListComponent } from '../../shared/component/list-filter/select.list.component';
import { DatePipe } from '@angular/common';
import { DashboardService } from '../../dashboard/dashboard.service';
import { Component, OnInit, OnChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SharedService } from '../../shared/shared.service';
import { UserService } from '../user/user.service';
import { MatSidenav } from '@angular/material';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';



declare var $: any;

@Component({
    selector: 'app-status-agents',
    templateUrl: './status-agents.component.html',
    styleUrls: ['./status-agents.component.scss']
})

export class StatusAgentsComponent implements OnInit, OnChanges {
    public _isReportChats: any;
    public _isReportWait: any;
    public _isReportArchived: any;
    public _isReportNivelService: any;
    public _isReportEstadosDeConexion: any;
    public _isReportInicioSesion: any;
    public _isReportAgents: any;
    public fechaActual: any;
    public myDate: any = new Date();
    public selectedItems2 = [];
    public selectedItems1 = [];
    public selectedItems3 = [];
    public selectedItems5 = [];

    public dropdownList2 = [];
    public dropdownList3 = [];
    public dropdownList4 = [];
    public dropdownList5 = [];

    public typeReportDetail: any;
    public typeReportConsol: any;
    public banderaData: any = false;
    public roomsMsg: any;
    public states: any;
    public title_toModal: string;
    public body_toModal: string;
    public list_var: any;
    public list_comments: any;
    public dataHistorialRooms: any;
    public text_class = "";

    public typeReportCon: any;
    public filter: FormGroup;
    public date_init: any = '';
    public date_end: any = '';
    public agent_selected: any = '';
    public tags_selected: any = '';

    public color = "";
    public info: any;
    public doughnut_average: boolean;
    public roomsTransfer: any = [] ;
    public idroom: string;
    public agents: any;
    public new_data_3: any = [];
    public dataExcel: any = [];
    public dataExcel_3: any = [];

    public dropdownList = [];
    public dropdownSettings: IDropdownSettings = {};
    public flagToDisplay = true;
    public newArray: any = [];
    public banderaRepor: any;

    public report_detail: any;
    public report_consolidated_1: any;
    public report_consolidated_2: any;
    public activarBotonDownload = false;

    constructor(
        private fb: FormBuilder,
        private _dashboardService: DashboardService,
        private spinner: NgxSpinnerService,
        private datePipe: DatePipe,
        public sharedService: SharedService,
        private userService: UserService,
        public toastr: ToastsManager
    ) {
        this.filter = this.fb.group({
            date_start_report: ['', Validators.required],
            date_end_report: ['', Validators.required],
            agent: [],
            report_type: ['', Validators.required],
            report_type_detalle: ['', Validators.required],
            nivel_servicio: [],
            shop: [],
            state_report: [],
            state_report_wait: [],
            type_report_view: ['', Validators.required],
            textoFiltro: [],
            checkVariable: [],
            tags: []
        });

        this._isReportNivelService = false;
        this.fechaActual = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    }

    ngOnInit() {
        this.typeReportConsol = 'd';

        this._isReportChats = true;
        this._isReportWait = true;

        this.filter.setValue({
            report_type: 'report_1',
            date_start_report: this.fechaActual,
            date_end_report: this.fechaActual,
            agent: '',
            report_type_detalle: 'detalle_chats_1',
            type_report_view: 'detail',
            nivel_servicio: 20,
            shop: '',
            state_report: '',
            state_report_wait: '',
            textoFiltro: '',
            checkVariable: '',
            tags: ''
        });

        let cookie = {
            auth_token: this.sharedService.getCookie("auth_token"),
        };

        this.userService.getAllAgentsInReport(cookie).subscribe(res => {
            this.dropdownList = res.data;
            this.flagToDisplay = false;
        }, error => {
            console.log('Ups, Hubo un error: ', error);
        });
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'fullname',
            selectAllText: 'Seleccionar Todos',
            unSelectAllText: 'Remover Todos',
            itemsShowLimit: 5,
            allowSearchFilter: true
        };

        let data = {
            auth_token: this.sharedService.getCookie("auth_token")
        };

        this.userService.getShop(data).subscribe(
            data => {
                let valuei = 0;
                this.dropdownList2 = data.data;

                console.log(this.dropdownList2);

            },
            error => { //server error
                //this.load = false;
                this.spinner.hide();
                this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
            }
        );

        this.userService.getIds(data).subscribe((returndata) => {
            this.dropdownList3 = returndata.message.descripciones;
            this.dropdownList4 = returndata.message.todosTags;

        });

        this.userService.getStatusPending(data).subscribe(
            data => {
                this.dropdownList5 = data.data;
            },
            error => { //server error
                //this.load = false;
                this.spinner.hide();
                this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
            }
        );

        this.report_detail = true;
        this.report_consolidated_1 = false;
        this.report_consolidated_2 = false;
    }
    onItemSelect(item: any) {
        console.log(item);
    }

    changeShop(item: any) {
        let arrayShop = [];

        if (this.filter.value.shop) {
            this.filter.value.shop.map(item => {
                arrayShop.push(
                    item.id
                );
            });
        }

        console.log(arrayShop);
    }

    ngOnChanges() {
        let arrayShop = [];

        if (this.filter.value.shop) {
            this.filter.value.shop.map(item => {
                arrayShop.push(
                    item.id
                );
            });
        }

        console.log(arrayShop);
    }

    consultarAgent(arrayShop) {
        let cookie = {
            auth_token: this.sharedService.getCookie("auth_token"),
            shop: arrayShop
        };

        console.log(cookie);

        this.userService.getAllAgentsInReport(cookie).subscribe(res => {
            this.dropdownList = res.data;
            this.flagToDisplay = false;
        }, error => {
            console.log('Ups, Hubo un error: ', error);
        });
    }

    OnItemDeSelectShop(item: any) {
        let arrayShop = [];

        if (this.filter.value.shop) {
            this.filter.value.shop.map(item => {
                arrayShop.push(
                    item.id
                );
            });
        }

        this.consultarAgent(arrayShop);
    }

    onItemSelectShop(item: any) {
        let arrayShop = [];

        if (this.filter.value.shop) {
            this.filter.value.shop.map(item => {
                arrayShop.push(
                    item.id
                );
            });
        }

        this.consultarAgent(arrayShop);
    }

    onDeSelectAllShop(item: any) {
        let arrayShop = [];
        this.consultarAgent(arrayShop);
    }

    onSelectAllShop(item: any) {
        let arrayShop = [];
        if (item) {
            item.map(item => {
                arrayShop.push(
                    item.id
                );
            });
        }
        this.consultarAgent(arrayShop);
    }

    onSelectAll(items: any) {
    }

    onChange(val: any) {
        this.banderaData = false;

        if (val == 'detail') {
            this.report_detail = true;
            this.report_consolidated_1 = false;
            this.report_consolidated_2 = false;
        } else if (val == 'consolidated') {
            this.report_consolidated_1 = true;
            this.report_consolidated_2 = false;
            this.typeReportDetail = '';
            this.report_detail = false;
        } else if (val == 'consolidated_2') {
            this.report_consolidated_1 = false;
            this.report_consolidated_2 = true;
            this.typeReportDetail = '';
            this.report_detail = false;
        }
    }

    onFilter() {


        if (this.report_detail) {
            this.typeReportDetail = "Reporte detallado";
        } else {
            this.typeReportDetail = "";
        }

        if (!this.filter.value.report_type_detalle) {
            this.toastr.warning('Debe seleccionar un tipo de reporte', 'Atención');
            return;
        }

        if (this._isReportArchived && !this.filter.value.state_report) {
            this.toastr.warning('Debe seleccionar un estado de cierre', 'Atención');
            return;
        }
        let actual_day = new Date();
        const collapseReport = document.getElementById('collapseReport');
        const collapseFilterReport = document.getElementById('collapseFilterReport');
        actual_day.setDate(actual_day.getDate()+60);

        let maxRango = this.datePipe.transform(actual_day, "yyyy-MM-dd");
        

        if (this.date_init > this.date_end || this.date_end > maxRango) {
            this.toastr.warning('Rango de Fechas Inválido', 'Atención');
            return;
        } else {
            this.agent_selected = [];

            this.newArray = [];

            if(this.sharedService.user.role_id == '3') {
                this.newArray.push(
                    this.sharedService.user.id
                );
            } else {
                this.agent_selected = this.filter.value.agent;
                if (this.agent_selected) {
                    this.agent_selected.map(item => {
                        this.newArray.push(
                            item.id
                        );
                    });
                }
            }

            this.date_init = this.filter.value.date_start_report;
            this.date_end = this.filter.value.date_end_report;
            this.tags_selected = this.filter.value.tags;

            this.banderaRepor = this.filter.value.report_type;

            if (this._isReportNivelService && this.newArray.length == 0) {
                this.toastr.warning('Debe seleccionar por lo menos un agente', 'Atención');

                return;
            }

            let arrayTags = [];

            if (this.filter.value.tags) {
                this.filter.value.tags.map(item => {
                    arrayTags.push(
                        item.id
                    );
                });
            }

            let arrayStateWait = [];

            if (this.filter.value.state_report_wait) {
                this.filter.value.state_report_wait.map(item => {
                    arrayStateWait.push(
                        item.id
                    );
                });
            }

            let arrayState = [];

            if (this.filter.value.state_report) {
                this.filter.value.state_report.map(item => {
                    arrayState.push(
                        item.id
                    );
                });
            }

            let arrayShop = [];

            if (this.filter.value.shop) {
                this.filter.value.shop.map(item => {
                    arrayShop.push(
                        item.id
                    );
                });
            }

            let data_to_backend = {
                rango_inicio: this.date_init,
                rango_fin: this.date_end,
                agents: this.newArray,
                report_type: this.filter.value.report_type,
                report_detail: this.report_detail,
                report_consolidated_1: this.report_consolidated_1,
                report_consolidated_2: this.report_consolidated_2,
                report_type_detalle: this.filter.value.report_type_detalle,
                tags: arrayTags,
                state_report_wait: arrayStateWait,
                state_report: arrayState,
                shop: arrayShop,
                nivel_servicio: this.filter.value.nivel_servicio,
                auth_token: this.sharedService.getCookie("auth_token"),
                filtro: this.filter.value.textoFiltro,
                soloVariable: this.filter.value.checkVariable
            };

            this.spinner.show();
            this.new_data_3 = [];
            this.dataExcel_3 = [];
            

            this._dashboardService.getDataReport(data_to_backend).subscribe(data => {

                if (data.data == false) {
                    this.banderaData = false;
                    this.spinner.hide();
                    this.toastr.info('No existen registros para mostrar', 'Atención');
                    
                    return;
                }
                
                this.banderaData = true;
                collapseReport.classList.remove('show');
                
                if (this.report_detail) {
                    //Información detallada de la tabla

                    if (this._isReportNivelService) {
                        for (let i in data.data) {
                            let temp = [];
                            let tempExcel = [];

                            tempExcel['Fecha'] = data.data[i].fecha;

                            temp['intervalo'] = data.data[i].intervalo;
                            tempExcel['Intervalo'] = temp['intervalo'];

                            temp['total_chats'] = data.data[i].total_chats;
                            tempExcel['Total de chats'] = temp['total_chats'];

                            temp['answered_chats'] = data.data[i].answered_chats;
                            tempExcel['Chats respondidos'] = temp['answered_chats'];

                            temp['total_closed'] = data.data[i].total_closed;
                            tempExcel['Chats finalizados'] = temp['total_closed'];

                            temp['agentes_conectados'] = data.data[i].agentes_conectados;
                            tempExcel['Agentes Conectados'] = temp['agentes_conectados'];

                            temp['chats_rango'] = data.data[i].chats_rango;
                            tempExcel['Chats dentro del rango'] = temp['chats_rango'];

                            temp['nivel_servicio'] = (data.data[i].nivel_servicio).toFixed(2) + "%";
                            tempExcel['Nivel de servicio'] = temp['nivel_servicio'];

                            temp['nivel_atencion'] = (data.data[i].nivel_atencion).toFixed(2) + "%";
                            tempExcel['Nivel de atención'] = temp['nivel_atencion'];

                            if (data.data[i].nivel_servicio <= 35) {
                                temp['color'] = "#f95555";
                                this.text_class = "text-white";
                            } else if ((data.data[i].nivel_servicio > 35) && (data.data[i].nivel_servicio <= 80)) {
                                temp['color'] = "#f38b56";
                                this.text_class = "text-white";
                            } else {
                                temp['color'] = "#75e44e";
                                this.text_class = "text-white";
                            }

                            if (data.data[i].nivel_atencion <= 35) {
                                temp['color_atencion'] = "#f95555";
                                this.text_class = "text-white";
                            } else if ((data.data[i].nivel_atencion > 35) && (data.data[i].nivel_atencion <= 80)) {
                                temp['color_atencion'] = "#f38b56";
                                this.text_class = "text-white";
                            } else {
                                temp['color_atencion'] = "#75e44e";
                                this.text_class = "text-white";
                            }

                            if (data.data[i].TMA) {
                                // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                                let h_tiempoTotal = Math.floor(data.data[i].TMA / 3600);         // Horas
                                let m_tiempoTotal = Math.floor((data.data[i].TMA % 3600) / 60);  // Minutos
                                let s_tiempoTotal = Math.floor((data.data[i].TMA % 3600) % 60);  // Segundos

                                temp['TMA_horas_activo'] = h_tiempoTotal > 0 ? (h_tiempoTotal > 9 ? h_tiempoTotal + ":" : "0" + h_tiempoTotal + ":") : "00:";
                                temp['TMA_minutos_activo'] = m_tiempoTotal > 0 ? (m_tiempoTotal > 9 ? m_tiempoTotal + ":" : "0" + m_tiempoTotal + ":") : "00:";
                                temp['TMA_segundos_activo'] = s_tiempoTotal > 0 ? (s_tiempoTotal > 9 ? s_tiempoTotal + "" : "0" + s_tiempoTotal + "") : "00";

                            } else {
                                temp['TMA_horas_activo'] = "00:";
                                temp['TMA_minutos_activo'] = "00:";
                                temp['TMA_segundos_activo'] = "00";
                            }

                            tempExcel['TMA'] = temp['TMA_horas_activo'] + temp['TMA_minutos_activo'] + temp['TMA_segundos_activo'];
                            

                            if (data.data[i].TME) {
                                // Cálculo de las horas minutos y segundos del tiempo promedio. Por Agente.
                                let h_tiempoTotalEspera = Math.floor(data.data[i].TME / 3600);
                                let m_tiempoTotalEspera = Math.floor(data.data[i].TME % 3600 / 60);
                                let s_tiempoTotalEspera = Math.floor((data.data[i].TME % 3600) % 60);

                                temp['TME_horas_espera'] = h_tiempoTotalEspera > 0 ? (h_tiempoTotalEspera > 9 ? h_tiempoTotalEspera + ":" : "0" + h_tiempoTotalEspera + ":") : "00:";
                                temp['TME_minutos_espera'] = m_tiempoTotalEspera > 0 ? (m_tiempoTotalEspera > 9 ? m_tiempoTotalEspera + ":" : "0" + m_tiempoTotalEspera + ":") : "00:";
                                temp['TME_segundos_espera'] = s_tiempoTotalEspera > 0 ? (s_tiempoTotalEspera > 9 ? s_tiempoTotalEspera + "" : "0" + s_tiempoTotalEspera + "") : "00";

                            } else {
                                temp['TME_horas_espera'] = "00:";
                                temp['TME_minutos_espera'] = "00:";
                                temp['TME_segundos_espera'] = "00";
                            }

                            tempExcel['TME'] = temp['TME_horas_espera'] + temp['TME_minutos_espera'] + temp['TME_segundos_espera'];

                            
                            if (data.data[i].TMC) {
                                // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                                let h_tiempoTotal_tmo = Math.floor(data.data[i].TMC / 3600);         // Horas
                                let m_tiempoTotal_tmo = Math.floor((data.data[i].TMC % 3600) / 60);  // Minutos
                                let s_tiempoTotal_tmo = Math.floor((data.data[i].TMC % 3600) % 60);  // Segundos

                                temp['TMC_horas_activo'] = h_tiempoTotal_tmo > 0 ? (h_tiempoTotal_tmo > 9 ? h_tiempoTotal_tmo + ":" : "0" + h_tiempoTotal_tmo + ":") : "00:";
                                temp['TMC_minutos_activo'] = m_tiempoTotal_tmo > 0 ? (m_tiempoTotal_tmo > 9 ? m_tiempoTotal_tmo + ":" : "0" + m_tiempoTotal_tmo + ":") : "00:";
                                temp['TMC_segundos_activo'] = s_tiempoTotal_tmo > 0 ? (s_tiempoTotal_tmo > 9 ? s_tiempoTotal_tmo + "" : "0" + s_tiempoTotal_tmo + "") : "00";
                            } else {
                                temp['TMC_horas_activo'] = "00:";
                                temp['TMC_minutos_activo'] = "00:";
                                temp['TMC_segundos_activo'] = "00";
                            }

                            tempExcel['TMC'] = temp['TMC_horas_activo'] + temp['TMC_minutos_activo'] + temp['TMC_segundos_activo']; 

                            this.new_data_3.push(temp);
                            this.dataExcel_3.push(tempExcel);
                        }
                    } else {

                        this.new_data_3 = data.data;

                        for (let i in data.data) {
                            let tempExcel = [];
                            if (this._isReportWait) {
                                tempExcel['Id de conversación'] = data.data[i].id_room;
                                tempExcel['Estado'] = data.data[i].status;
                                tempExcel['Segmento'] = data.data[i].tienda;
                                tempExcel['Id de sesión'] = data.data[i].session_id;
                                tempExcel['Id botai'] = data.data[i].sender_id_bot;
                                tempExcel['Plataforma'] = data.data[i].plataforma;
                                tempExcel['Fecha entrada'] = data.data[i].created_at;
                                tempExcel['Fecha salida'] = data.data[i].date_end;
                                tempExcel['Tiempo en espera'] = data.data[i].tiempoEspera;
                                for (let k in data.data[i].variablesRoom) {  
                                    tempExcel[data.data[i].variablesRoom[k].clave] = data.data[i].variablesRoom[k].valor;
                            }
                            }

                            if (this._isReportArchived) {
                                tempExcel['Id de conversación'] = data.data[i].id_room;
                                tempExcel['Estado'] = data.data[i].status;
                                tempExcel['Segmento'] = data.data[i].tienda;
                                tempExcel['Agente'] = data.data[i].agente;
                                tempExcel['Id de sesión'] = data.data[i].session_id;
                                tempExcel['Id botai'] = data.data[i].sender_id_bot;
                                tempExcel['Plataforma'] = data.data[i].plataforma;
                                tempExcel['Zona horaria'] = data.data[i].time_zone;
                                tempExcel['Fecha ingreso a cola'] = data.data[i].fecha_ingreso;
                                tempExcel['Fecha asignación agente'] = data.data[i].fecha_asigAgente;
                                tempExcel['Fecha inicio'] = data.data[i].fecha_ini;
                                tempExcel['Fecha fin'] = data.data[i].fecha_fin;
                                tempExcel['Tiempo espera en cola'] = data.data[i].tec;
                                tempExcel['Tiempo espera del usuario'] = data.data[i].te;
                                tempExcel['Tiempo interacción del usuario'] = data.data[i].tau;
                                tempExcel['Tiempo promedio de respuesta del usuario'] = data.data[i].tmau;
                                tempExcel['Cantidad de mensajes enviados por el usuario'] = data.data[i].cmu;
                                tempExcel['Cantidad de mensajes enviados por el agente '] = data.data[i].cma;
                                tempExcel['Tiempo atencion del agente'] = data.data[i].taa;
                                tempExcel['Tiempo promedio de atencion del agente'] = data.data[i].tmaa;
                                tempExcel['Tiempo de envio del mensaje de inactividad'] = data.data[i].tim;
                                tempExcel['Tiempo de cierre de conversación '] = data.data[i].tcem;
                                tempExcel['Tiempo de atención'] = data.data[i].tti;
                                tempExcel['Tiempo de conversacion'] = data.data[i].tc;
                                tempExcel['Tiempo total'] = data.data[i].time_total;
                                tempExcel['Tiempo en otras operaciones'] = data.data[i].totalTimeTransfer;
                                tempExcel['Tiempo de videollamadaPA'] = data.data[i].timeVideocallPA;
                                tempExcel['Tiempo de videollamada Aplicativo'] = data.data[i].timeVideocallSdk;
                                tempExcel['Link de grabación'] = data.data[i].urlVideocall;


                                if(data.data[i].transfer !== ''){
                                    let contTrans = 0;
                                    for (const trans of data.data[i].transfer) {
                                    
                                    for (const key in trans) { 
                                        tempExcel['Transferida' + contTrans + ' ' + `${key}`] = `${trans[key]}`;
                                    }
                                    contTrans++;
                                }
                                }else{
                                    tempExcel['Transferida'] = 'N/A'
                                }
                                

                                let cont = 0;
                                for (let k in data.data[i].tagsE) {  
                                    cont++;
                                    let cont2 = 1;
                                    for (let l in data.data[i].tagsE[k]) {
                                        tempExcel['Etiqueta' + cont + ' Nivel' + cont2] = data.data[i].tagsE[k][l];
                                        cont2++;
                                    }
                                }
                                
                                for (let k in data.data[i].variablesRoom) {  
                                        tempExcel[data.data[i].variablesRoom[k].clave] = data.data[i].variablesRoom[k].valor;
                                }

                                let contComen = 0;
                                for (let k in data.data[i].comentarios) {  
                                    contComen++;
                                        tempExcel['Comentario' + contComen ] = data.data[i].comentarios[k].text;
                                    
                                }

                            }

                            if (this._isReportAgents) {
                                tempExcel['Agente'] = data.data[i].agent;
                                tempExcel['Estado'] = data.data[i].status;
                                tempExcel['Zona horaria'] = data.data[i].time_zone;
                                tempExcel['Dia'] = data.data[i].day;
                                tempExcel['Hora'] = data.data[i].hour;
                                tempExcel['Tiempo'] = data.data[i].time_elapsed;
                                
                            }

                            this.dataExcel_3.push(tempExcel);
                        }
                    }
                    

                } else {
                    if (this._isReportNivelService) {
                        for (let i in data.data) {
                            let temp = [];
                            let tempExcel = [];

                            if (this.report_consolidated_2) {
                                temp['agente'] = data.data[i].agente;
                                tempExcel['Agente'] = temp['agente'];
                            }

                            temp['intervalo'] = data.data[i].intervalo;
                            tempExcel['Intervalo'] = temp['intervalo'];

                            temp['total_chats'] = data.data[i].total_chats;
                            tempExcel['Total de chats'] = temp['total_chats'];

                            temp['answered_chats'] = data.data[i].answered_chats;
                            tempExcel['Chats respondidos'] = temp['answered_chats'];

                            temp['total_closed'] = data.data[i].total_closed;
                            tempExcel['Chats finalizados'] = temp['total_closed'];

                            temp['agentes_conectados'] = data.data[i].agentes_conectados;
                            tempExcel['Agentes Conectados'] = temp['agentes_conectados'];

                            temp['chats_rango'] = data.data[i].chats_rango;
                            tempExcel['Chats dentro del rango'] = temp['chats_rango'];

                            temp['nivel_servicio'] = data.data[i].nivel_servicio + "%";
                            temp['nivel_atencion'] = data.data[i].nivel_atencion + "%";

                            if (data.data[i].nivel_servicio <= 35) {
                                temp['color'] = "#f95555";
                                this.text_class = "text-white";
                            } else if ((data.data[i].nivel_servicio > 35) && (data.data[i].nivel_servicio <= 80)) {
                                temp['color'] = "#f38b56";
                                this.text_class = "text-white";
                            } else {
                                temp['color'] = "#75e44e";
                                this.text_class = "text-white";
                            }

                            if (data.data[i].nivel_atencion <= 35) {
                                temp['color_atencion'] = "#f95555";
                                this.text_class = "text-white";
                            } else if ((data.data[i].nivel_atencion > 35) && (data.data[i].nivel_atencion <= 80)) {
                                temp['color_atencion'] = "#f38b56";
                                this.text_class = "text-white";
                            } else {
                                temp['color_atencion'] = "#75e44e";
                                this.text_class = "text-white";
                            }

                            tempExcel['Nivel de servicio'] = temp['nivel_servicio'];
                            tempExcel['Nivel de atención'] = temp['nivel_atencion'];

                            temp['TMA'] = data.data[i].TMA;
                            tempExcel['TMA'] = data.data[i].TMA;

                            temp['TME'] = data.data[i].TME;
                            tempExcel['TME'] = data.data[i].TME;

                            temp['TMC'] = data.data[i].TMC;
                            tempExcel['TMC'] = data.data[i].TMC;

                            this.new_data_3.push(temp);
                            this.dataExcel_3.push(tempExcel);
                            
                        }
                    } else {
                        this.info = data.data;
                        
                        this.typeReportConsol = 'd';

                        for (let i = 0; i < this.info.length; i++) {
                            this.info[i].serie3 = this.info[i].serie;
                        }

                        if (this._isReportChats && this._isReportWait) {
                            if (this.report_consolidated_1) {
                                for (let i in data.data) {
                                    let tempExcel = [];
                                    tempExcel['Estado'] = data.data[i].serie;
                                    tempExcel['Cantidad'] = data.data[i].quantity;
                                    this.dataExcel_3.push(tempExcel);
                                }
                            } else {
                                for (let i in data.data) {
                                    let tempExcel = [];
                                    tempExcel['Segmento'] = data.data[i].tienda;
                                    tempExcel['Estado'] = data.data[i].serie2;
                                    tempExcel['Cantidad'] = data.data[i].quantity;
                                    this.dataExcel_3.push(tempExcel);
                                }
                            }
                        }

                        if (this._isReportChats && this._isReportArchived) {
                            if (this.report_consolidated_1) {
                                for (let i in data.data) {
                                    let tempExcel = [];
                                    tempExcel['Estado'] = data.data[i].serie;
                                    tempExcel['Cantidad'] = data.data[i].quantity;
                                    tempExcel['TMCE'] = data.data[i].tec;
                                    tempExcel['TME'] = data.data[i].te;
                                    tempExcel['TMIU'] = data.data[i].tmiu;
                                    tempExcel['TMAA'] = data.data[i].tmaa;
                                    tempExcel['TMMI'] = data.data[i].tim;
                                    tempExcel['TMCC'] = data.data[i].tmc;
                                    tempExcel['TMA'] = data.data[i].tma;
                                    tempExcel['TMC'] = data.data[i].tmc;
                                    tempExcel['TMO'] = data.data[i].time_total;
                                    this.dataExcel_3.push(tempExcel);
                                }
                            } else {
                                for (let i in data.data) {
                                    let tempExcel = [];
                                    tempExcel['Agente'] = data.data[i].agente;
                                    tempExcel['Estado'] = data.data[i].serie2;
                                    tempExcel['Cantidad'] = data.data[i].quantity;
                                    tempExcel['TEC'] = data.data[i].tec;
                                    tempExcel['TE'] = data.data[i].te;
                                    tempExcel['TIU'] = data.data[i].tiu;
                                    tempExcel['TMIU'] = data.data[i].tmiu;
                                    tempExcel['TMAA'] = data.data[i].tmaa;
                                    tempExcel['TMMI'] = data.data[i].tim;
                                    tempExcel['TMCC'] = data.data[i].tmc;
                                    tempExcel['TMA'] = data.data[i].tma;
                                    tempExcel['TMC'] = data.data[i].tmc;
                                    tempExcel['Tiempo total'] = data.data[i].time_total;
                                    this.dataExcel_3.push(tempExcel);
                                }
                            }
                        }

                        if (this._isReportAgents) {
                            for (let i in data.data) {
                                let tempExcel = [];
                                tempExcel['Estado'] = data.data[i].estado;
                                tempExcel['Agente'] = data.data[i].agente;
                                tempExcel['Tiempo'] = data.data[i].tiempo;
                                console.log(tempExcel);
                                this.dataExcel_3.push(tempExcel);
                            }
                        }
                    }
                }
                this.spinner.hide();
            }, error => {
                //console.log(error);
                this.spinner.hide();
            })
        }
    }

    exportAsXLSX(): void {
        if ('chats' == this.banderaRepor) {
            this.userService.exportAsExcelFile(this.dataExcel, 'reporte');
        } else {
            this.userService.exportAsExcelFile(this.dataExcel_3, 'reporte');
        }
    }

    changeTipeReportCon(valor) {
        this.typeReportCon = valor;
    }

    customizeLabel(point) {
        console.log(point);
        let percent_truncate = (point.percent * 100).toFixed(1);
        return point.argumentText + ': ' + point.valueText + ' (' + percent_truncate + '%' + ')' + '';
    }

    selectReport(e) {
        this.banderaData = false;

        if (e == 'report_1') {
            this.filter.get('report_type_detalle').setValue('detalle_chats_1');
            this._isReportWait = true;
            this._isReportChats = true;
            this._isReportAgents = false;
            this._isReportNivelService = false;
            this._isReportInicioSesion = false;
            this._isReportEstadosDeConexion = false;
        } else {
            this.filter.get('report_type_detalle').setValue('detalle_agent_1');
            this._isReportEstadosDeConexion = true;

            this._isReportChats = false;
            this._isReportArchived = false;
            this._isReportWait = false;
            this._isReportAgents = true;
        }
    }

    selectReportDetalle1(e) {
        this.filter.get('type_report_view').setValue('detail');
        this.report_detail = true;
        this.report_consolidated_1 = false;
        this.report_consolidated_2 = false;

        this.banderaData = false;
        if (e == 'detalle_chats_1') {
            this._isReportArchived = false;
            this._isReportWait = true;
        } else {
            this._isReportArchived = true;
            this._isReportWait = false;
        }
    }

    selectReportDetalle2(e) {
        this.banderaData = false;
        if (e == 'detalle_agent_3') {
            this._isReportNivelService = true;
        } else {
            this._isReportNivelService = false;
        }

        if (e == 'detalle_agent_1') {
            this._isReportEstadosDeConexion = true;
        } else {
            this._isReportEstadosDeConexion = false;
        }

        if (e == 'detalle_agent_2') {
            this._isReportInicioSesion = true;
        } else {
            this._isReportInicioSesion = false;
        }
    }

    changeTypeReportCon(e) {
        this.typeReportConsol = e;
    }

    verConversacion(id) {
        if (id) {
            this.spinner.show();

            let data = {
                auth_token: this.sharedService.getCookie('auth_token'),
                room_id: id,
            };

            this.userService.getRoomMsgs(data).subscribe(
                data => {
                    if (data.status) {
                        if (data.data) {
                            if (!this.roomsMsg)
                                this.roomsMsg = {};

                            if (!this.roomsMsg.msgs) {
                                this.roomsMsg.msgs = [];
                            }

                            if (this.roomsMsg.msgs.length === 0) {
                                this.dataHistorialRooms = data.data.dataReport;
                                this.roomsMsg.msgs = data.data.data;
                            } else {
                                this.roomsMsg.msgs = [];
                                this.roomsMsg.msgs = data.data.data;
                                this.dataHistorialRooms = data.data.dataReport;
                            }

                            console.log(this.roomsMsg.msgs);
                            //this.load = false;
                            this.states = {
                                currentPage: this.roomsMsg.current_page = data.data.current_page,
                                lastPage: this.roomsMsg.current_page = data.data.last_page
                            };
                        }
                        //   }

                    } else {
                        //this.load = false;
                    }

                    this.spinner.hide();

                    this.title_toModal = "Conversación No. " + id;
                    this.body_toModal = "Si hay información";
                    $('#historialRooms').modal('toggle', { backdrop: false });
                    $('#historialRooms').appendTo("body");

                },
                error => {
                    console.log("Justo antes");

                }
            );
        }
    }
    
    verVariables(id,session_id,created_at) {
        this.spinner.show();

        let data = {
            auth_token: this.sharedService.getCookie('auth_token'),
            id_room_pending: id,
            session_id:session_id,
            created_at:created_at,
            // page: id_page
        };

        this.userService.getVariablesPending(data).subscribe(
            data => {
                this.spinner.hide();
                this.list_var = data.data;
                if (data.message == 'failVariables') {
                    this.toastr.info("No hay variables asociadas", 'Atención');
                } else {
                    this.title_toModal = "Pendientes - Información del usuario No. " + id;
                    this.body_toModal = "Si hay información";
                    $('#variablesRoomAgent').modal('toggle', { backdrop: false });
                    $('#variablesRoomAgent').appendTo("body");
                }
            },
            error => {
            }
        );

    }

    verVariablesRooms(id) {
        this.spinner.show();

        let data = {
            auth_token: this.sharedService.getCookie('auth_token'),
            id_room: id
        };

        this.userService.getVariablesRooms(data).subscribe(
            data => {
                this.spinner.hide();
                this.list_var = data.data;
                console.log(this.list_var);
                if (data.message == 'failVariables') {
                    this.toastr.info("No hay variables asociadas", 'Atención');
                } else {
                    this.title_toModal = "Información del usuario No. " + id;
                    this.body_toModal = "Si hay información";
                    $('#variablesRoomAgent').modal('toggle', { backdrop: false });
                    $('#variablesRoomAgent').appendTo("body");
                }
            },
            error => {
            }
        );
    }

    seeCommentsRooms(id) {
        this.spinner.show();

        let data = {
            auth_token: this.sharedService.getCookie('auth_token'),
            room_id: id,
            // page: id_page
        };

        this.userService.getInfoComments(data).subscribe(
            data => {
                this.spinner.hide();
                this.list_comments =data.data.data;
                //console.log(this.list_comments);
                if (this.list_comments.length === 0) {
                    this.toastr.info("No hay comentarios asociados", 'Atención');
                } else {
                    this.title_toModal = "Comentarios del agente No. " + id;
                    this.body_toModal = "Si hay información";
                    $('#comments').modal('toggle', { backdrop: false });
                    $('#comments').appendTo("body");
                }
            },
            error => {
            }
        );
    }

    verTransferidas(data,id){
        
        if (data.length === 0) {
            this.toastr.info("No hay salas asociadas", 'Atención');
        } else {
            this.idroom= id;
            this.roomsTransfer = data;
            $('#roomsTransfer').modal('toggle');
            $('#roomsTransfer').appendTo("body");
        }
        
    }


    //Activar boton de descargar excel
    validarClic() {
        this.activarBotonDownload = true;
    }
    

    exportHistorialExc():void {
        this.userService.exportAsExcelFile(this.dataHistorialRooms, 'reporte_historial');
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status-agents/status-agents.component.ts